import * as React from 'react';
import {observer} from 'mobx-react';
import {AddressSchema} from '../types/schema';
import {createAddressForm, createForm, createFormField, resetFormErrors} from '../lib/form';
import {Form} from './form';
import {style} from 'typestyle';
import {flex1, horizontal, horizontallySpaced, vertical, verticallySpaced} from 'csstips';
import {mediaMobileOnly, mediaTablet} from '../theme/media';
import {FormAddressLookup} from './form-address-lookup';
import {noop} from '../lib/helpers';
import {addressToLabel, suggestionToAddress} from '../lib/address';
import {LocationSuggestion} from '../types';

export interface PageCheckoutAddressProps {
  address: AddressSchema;
  addresses: Array<AddressSchema>;
  addressError?: string;
  onSelectAddress(address: AddressSchema): void;
}

@observer
export class PageCheckoutAddress extends React.Component<PageCheckoutAddressProps, any> {
  render() {
    return (
      <div className={PageCheckoutAddress.styles.container}>
        <div>
          <Form
            model={this.state.select}
            onChange={this.handleChangeAddress}
            onSubmit={noop}
            noButtons={true}
          />
          <FormAddressLookup
            onSuggestion={this.handleLocationSuggestion}
          />
        </div>
        <Form
          model={this.state.form}
          onChange={this.handleFormChange}
          onSubmit={noop}
          noButtons={true}
        />
      </div>
    )
  }

  constructor(props: PageCheckoutAddressProps) {
    super(props);
    this.state = this.initialState(props.address, props.addresses);
  }

  initialState = (address, addresses) => ({
    address,
    select: createForm({
      address: createFormField({
        name: 'address',
        label: 'Existing addresses',
        value: address,
        type: 'address',
        options: addresses.map((address) => ({ value: address, label: addressToLabel(address) }))
      })
    }),
    form: createAddressForm(address ? address : void 0)
  });

  componentDidMount() {
    this.updateErrors(this.props.addressError);
  }

  componentWillReceiveProps(props: PageCheckoutAddressProps) {
    const { address, addresses, addressError } = props;
    const { state } = this;

    const changed = this.props.address !== address
      || !address
      || !state.address
      || Object.keys(address).find(key => address[key] !== state.address[key]);

    if (changed) {
      this.setState(this.initialState(address, addresses), () => this.updateErrors(addressError));
    } else {
      this.updateErrors(addressError);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.address !== this.state.address) {
      this.props.onSelectAddress(this.state.address);
    }
  }

  updateErrors = (addressError: string) => {
    resetFormErrors(this.state.form);
    if (!addressError) return;

    this.state.form.error = addressError;
  };

  handleChangeAddress = (field: string, address: AddressSchema) => {
    this.state.select.fields.address.value = address;

    this.setState({
      form: createAddressForm(address),
      address
    });
  };

  handleFormChange = (field: string, value: any) => {
    this.state.select.fields.address.value = null;

    const { fields } = this.state.form;
    fields[field].value = value;

    const address = Object.keys(this.state.form.fields).reduce((address, field) => ({
      ...address,
      [field]: fields[field].value
    }), {});

    this.setState({ address });
  };

  handleLocationSuggestion = (suggestion: LocationSuggestion) => {
    const address = suggestionToAddress(suggestion);
    this.state.select.fields.address.value = null;

    this.setState({
      form: createAddressForm(address),
      address
    })
  };

  static styles = {
    container: style(
      mediaMobileOnly({
        ...vertical,
        ...verticallySpaced(30)
      }),
      mediaTablet({
        ...horizontal,
        ...horizontallySpaced(30),
        $nest: {
          '& > *': {
            ...flex1
          }
        }
      })
    )
  }
}